import { useEffect, useState } from 'react';

export function TourneyTimer(props: { timeStart: number }) {
  type Time = {
    hours?: number;
    minutes?: number;
    second?: number;
    day?: number;
  };
  const [time, setTime] = useState<Time>();

  useEffect(() => {
    const now = Date.now();
    const ms_left = props.timeStart - now;
    if (ms_left <= 0) {
      return;
    } else if (ms_left > 86400000) {
      const res = Math.floor(ms_left / 86400000);
      setTime({
        day: res,
      });
    } else {
      const res = new Date(ms_left);
      setTime({
        hours: res.getUTCHours(),
        minutes: res.getUTCMinutes(),
        second: res.getUTCSeconds(),
      });
    }

    const timer = setInterval(() => {
      const now = Date.now();
      const ms_left = props.timeStart - now;
      if (ms_left <= 0) {
        clearInterval(timer);
      } else if (ms_left > 86400000) {
        const res = Math.floor(ms_left / 86400000);
        setTime({
          day: res,
        });
      } else {
        const res = new Date(ms_left);
        setTime({
          hours: res.getUTCHours(),
          minutes: res.getUTCMinutes(),
          second: res.getUTCSeconds(),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [props.timeStart]);

  return (
    <span>
      {time && time.day
        ? `> ${time.day} day`
        : time && time.second
        ? `${time.minutes} min  ${time.second} sec`
        : ''}
    </span>
  );
}
